import { GlyphLoading } from "#root/components/glyphs";
import { getDeploymentCollectionForAccount } from "#root/schema/deployment";
import { useData } from "#root/utility/hooks";
import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import PageLayout from "./layout";

export default function (): ReactNode {
  const [deployments] = useData(async () => {
    const { rows } = await getDeploymentCollectionForAccount("self").list();
    return rows;
  }, [true]);

  if (!deployments) {
    return (
      <PageLayout title="Deployments">
        <section>
          <GlyphLoading/>
        </section>
      </PageLayout>
    );
  }

  return (
    <PageLayout title="Deployments">
      <section>
        <h1>Deployments</h1>
        <p>Manage your CloudQuote API deployments. Each deployment has its own credentials and usage tracking.</p>
        <DeploymentList deployments={deployments}/>
      </section>
    </PageLayout>
  );
}

function DeploymentList({ deployments }) {
  if (!deployments) {
    return <GlyphLoading/>;
  }

  return (
    <table className="deployment-list">
      <thead>
      <tr>
        <th>Id</th>
        <th>Deployment Name</th>
        <th>Status</th>
        <th>Manage</th>
      </tr>
      </thead>
      <tbody>
      {deployments.map(deployment => (
        <tr key={deployment.id}>
          <td>CD-{deployment.id}</td>
          <td>{deployment.name}</td>
          <td>{deployment.status}</td>
          <td>
            <Link to={"/account/deployment/" + deployment.id + "/usage"}>API Usage</Link>&nbsp;&middot;&nbsp;
            <Link to={"/account/deployment/" + deployment.id + "/credentials"}>Credentials</Link>
          </td>
        </tr>
      ))}
      </tbody>
    </table>
  );
}
